import { render } from "./NavigationView.vue?vue&type=template&id=5bc167d4&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=5bc167d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc167d4"]])

export default __exports__